export type PaintStatus = 
  | "uploaded"
  | "processing"
  | "available"
  | "error"
  | "review-required"
  | "rejected"
  | "approved";

export type FileType = 
  | "mas-file"
  | "image-front-angle"
  | "image-top-down";

export interface Paint {
  id: string;
  paintId: string;
  vehicleId: string;
  uri: string;
  status: PaintStatus;
  files: PaintFile[];
  times: Time[];
  updated: Date;
}

export function getImage(paint: Paint): string {
  const imageFile = paint.files.find(file => file.type === "image-front-angle");
  return imageFile ? imageFile.uri : "";
};

export interface PaintResponse {
  id: string;
  updated: Date;
  uri: string;
}

export interface PaintFile {
  type: FileType;
  name: string;
  uri: string;
}

export interface Time {
  event: string;
  occuredAt: Date;
  actionedBy: string;
}
